import Vue from 'vue';
import gridProps from '@/gridProps';

import {
  formatNumber,
  alignForNumber,
  autoResize,
  LinkCellRenderer,
} from '@/helpers/renderHelpers';
import {addColIdToColumns, handlerResponse} from '@/helpers/commonHelpers'

export default {
  namespaced: true,
  state: {
    roles: [],
    partners: [],
    partnersCount: null,
    partnersColumns: [],
    partnersGridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value);
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      },
      onGridReady() {
        this.api.showLoadingOverlay();
      }
    },
    gridName: ''
  },
  getters: {
    partners(state) {
      return state.partners;
    },
    roles(state) {
      return state.roles;
    },
    partnersColumns(state) {
      return state.partnersColumns;
    },
    partnersGridOptions(state) {
      return {...state.partnersGridOptions, ...gridProps, components: {
        'PartnerLink': LinkCellRenderer('id', '/partners/')
      }};
    },
    partnersCount(state) {
      return state.partnersCount
    }
  },
  mutations: {
    getRoles(state, payLoad) {
      state.roles = payLoad;
    },
    getPartners(state, payLoad) {
      state.partners = payLoad.data.results;
      state.partnersColumns = addColIdToColumns(payLoad.used_columns);
      state.partnersCount = payLoad.data.count;
      state.gridName = payLoad.grid_name;
    }
  },
  actions: {
    loadRoles(store, payLoad) {
      Vue.http.get('partner/partner_roles/', {params: payLoad})
        .then(handlerResponse)
        .then(data => {
          store.commit('getRoles', data);
        });
    },
    loadPartners(store, payLoad) {
      if(store.getters.partnersGridOptions.api) {
        store.getters.partnersGridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('partner/search_for_partners/', {params: payLoad})
        .then(handlerResponse)
        .then(data => {
          store.commit('getPartners', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/general/partners/generalPartners.js